interface EnteralNutritionType {
  currentStageSequence: number,
  dosageQuantity: number,
  dosageType: string,
  dosageTypeDescription: string,
  doseQuantity: number,
  gridStatus: string,
  infusedVolume: number,
  infusionSpeed: number,
  intervalCode: string,
  isPdo: string,
  materialCode: number,
  materialDescription: string,
  materialSequence: number,
  partialVolume: number,
  pendingHours?: number,
  prescriptionNumber: number,
  routeAdministrationDescription: string,
  scheduleDate: string,
  scheduleSequence: number,
  stageSequence: number,
  stageVolume: number,
  statusItem: string,
  unitMeasureDoseCode: string,
  unitMeasureDoseDescription: string
  unitMeasureInfusionSpeed: string
}

interface GenerateChangePrescribedSolutionParams {
  changeDate: string;
  dateTime: string,
  despisedVolumeQuantity: number;
  dosageType: string;
  encounterNumber: number;
  infusedVolumeQuantity: number;
  infusionVelocityQuantity: number;
  justificationDescription: string;
  partialVolumeQuantity: number;
  prescriptionNumber: number;
  reasonSequenceNumber: number;
  solutionSequenceNumber: number;
  volumePhaseQuantity: number;
}

interface ResponseBodyProps {
  hourDate?: string;
  informDose?: boolean;
  materialCode?: number;
  message?: string;
  messageType?: string;
  read?: boolean;
  success?: boolean;
  total?: number;
  totalRead?: number;
  unitMeasure?: string;
  unitMeasureValue?: string
}

enum EventType {
  BLOOD_SUSPENSION = 'SB',
  DRUGS_SUSPENSION = 'SI',
  INTERRUPTION_OF_SOLUTIONS = 'IS',
  SUSPENSION_OF_SOLUTIONS = 'SS',
  SUSPENSION_STEP_SOLUTION = 'SE'
}

interface ReasonInterrupt {
  emarInterruptReasonSequence: number;
  eventStatus: EventType;
  isBottleExchange: boolean;
  observationStatus: string;
  reasonDescription: string;
  requiresVolumeStatus: string;
}

interface ReasonType {
  reasonDescription: string;
  reasonStatus: string
  sequenceNumber: number;
}

interface GenerateChangePrescribedSolutionResponse {
  messageDescription: string;
}

export {
  EnteralNutritionType,
  EventType,
  GenerateChangePrescribedSolutionParams,
  GenerateChangePrescribedSolutionResponse,
  ReasonInterrupt,
  ResponseBodyProps,
  ReasonType
};
